export type StorefrontFulfillment = 'pickup' | 'delivery' | 'table' | 'digital';

export function resolveCheckoutFulfillment(
  choices: StorefrontFulfillment[],
  stored?: StorefrontFulfillment,
  initial?: StorefrontFulfillment,
): StorefrontFulfillment {
  if (stored && choices.includes(stored)) return stored;
  if (initial && choices.includes(initial)) return initial;
  return choices[0] ?? 'pickup';
}

export function checkoutAnonymousCustomerName(
  fulfillment: StorefrontFulfillment,
  originTableName?: string,
): string {
  return fulfillment === 'table' && originTableName ? `Client de ${originTableName}` : 'Client';
}

export function paymentChoicesForMode(
  mode: 'disabled' | 'optional' | 'required' | undefined,
): Array<'online' | 'offline'> {
  if (mode === 'required') return ['online'];
  if (mode === 'optional') return ['online', 'offline'];
  return ['offline'];
}

interface StorefrontFulfillmentPage {
  layout?: string | null;
  fulfillment_options?: StorefrontFulfillment | 'both';
  settings?: Record<string, unknown> | null;
}

export function isRestaurantStorefront(page?: StorefrontFulfillmentPage | null): boolean {
  if (!page) return false;

  if (typeof page.settings?.restaurant_enabled === 'boolean') {
    return page.settings.restaurant_enabled;
  }

  return page.layout === 'restaurant' || page.settings?.is_table_service_enabled === true;
}

export function isTableServiceEnabled(page?: StorefrontFulfillmentPage | null): boolean {
  return (
    page?.settings?.restaurant_enabled !== false &&
    page?.settings?.is_table_service_enabled === true
  );
}

export function fulfillmentChoicesForPage(
  page: StorefrontFulfillmentPage,
): StorefrontFulfillment[] {
  const restaurant = isTableServiceEnabled(page);
  if (
    Array.isArray(page.settings?.allowed_fulfillments) &&
    page.settings.allowed_fulfillments.length > 0
  ) {
    const valid: StorefrontFulfillment[] = ['table', 'pickup', 'delivery'];
    const filtered = (page.settings.allowed_fulfillments as string[]).filter(
      (f): f is StorefrontFulfillment => valid.includes(f as StorefrontFulfillment),
    );
    if (restaurant) {
      return ['table', ...filtered.filter((mode) => mode !== 'table')];
    }
    const commerceChoices = filtered.filter((mode) => mode !== 'table');
    if (commerceChoices.length > 0) return commerceChoices;
  }

  if (restaurant) {
    if (page.fulfillment_options === 'both') return ['table', 'pickup', 'delivery'];
    if (page.fulfillment_options === 'delivery') return ['table', 'delivery'];
    if (page.fulfillment_options === 'pickup') return ['table', 'pickup'];
    return ['table'];
  }

  if (page.fulfillment_options === 'both') return ['pickup', 'delivery'];
  return [page.fulfillment_options === 'delivery' ? 'delivery' : 'pickup'];
}
